export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
                关于布丁
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  布丁漫画是一个专注于下拉式阅读体验的漫画在线阅读平台。我们深知漫画读者对流畅阅读的渴望——频繁的翻页、卡顿的加载、画质压缩，这些都在破坏你的阅读沉浸感。因此，我们打造了布丁漫画下拉式阅读专区，让每一话漫画都能一滑到底，阅读不卡顿一气呵成。
                </p>
                <p>
                  平台收录了海量<strong>韩漫、国漫、日漫</strong>全集资源，涵盖恋爱、奇幻、逆袭、穿越、悬疑、热血、搞笑、都市、校园、古风、复仇等全题材类型。无论是热门连载还是经典完结作品，都可以在布丁漫画免费阅读，无需付费订阅。
                </p>
                <p>
                  我们的编辑团队每日精选优质内容，热门漫画同步更新，让你第一时间追到最新剧情。布丁漫画，重新定义你的漫画观看方式——<strong>下拉式阅读，滑动之间故事无限。</strong>
                </p>
              </div>
              <div className="flex flex-wrap gap-4 mt-6">
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-50 text-primary-600 text-sm font-medium">
                  <i className="ri-shield-check-line"></i>
                  <span className="whitespace-nowrap">正版授权</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-accent-50 text-accent-600 text-sm font-medium">
                  <i className="ri-speed-up-line"></i>
                  <span className="whitespace-nowrap">高速加载</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary-100 text-secondary-700 text-sm font-medium">
                  <i className="ri-device-line"></i>
                  <span className="whitespace-nowrap">多端适配</span>
                </div>
              </div>
            </div>

            <div className="flex-1 flex justify-center">
              <div className="relative w-full max-w-sm aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20a%20tablet%20displaying%20colorful%20manga%20art%2C%20warm%20ambient%20lighting%2C%20surrounded%20by%20bookshelves%2C%20soft%20coral%20and%20amber%20warm%20tones%2C%20comfortable%20atmosphere%2C%20clean%20modern%20composition%2C%20editorial%20style%20photography&width=800&height=600&seq=about-comic-bg&orientation=landscape"
                  alt="布丁漫画下拉式阅读 - 舒适阅读场景"
                  className="w-full h-full object-cover"
                  title="布丁漫画下拉式阅读体验"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}